import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-secondary-btn',
  templateUrl: './app-secondary-btn.component.html',
  styleUrls: ['./app-secondary-btn.component.scss']
})
export class AppSecondaryBtnComponent implements OnInit {
  @Input() btnText: string | undefined;
  @Input() componentId: string | undefined;
  @Input() disableBtn: boolean = false;

  @Output() clickEmitter: EventEmitter<MouseEvent> = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  emitClick(event: MouseEvent) {
    this.clickEmitter.emit(event);
  }
}
